/**
 * Pattern to retrieve escaped Unicode values from the `htmlEscape` function. Includes a negative
 * lookahead to filter out character codes that we do not want to reverse: <>& Includes a capture
 * group (position 2) to extract the character code value Example: 朋友 => 朋友
 */
const unicodePatternsToReverse = /&#(?!(38|60|62);)([\d]{1,5});/g;

/**
 * Pattern to retrieve escaped Unicode values from the `htmlEscape` function. Does NOT a filter for
 * dangerous character codes: `<>&`, instead includes a meaningless capture group so that it has the
 * same output structure as`unicodePatternsToReverse`. Includes a capture group (position 2) to
 * extract the character code value Example: 朋友 => 朋友
 */
const unsafeUnicodePatternsToReverse = /(&#)([\d]{1,5});/g;

/**
 * Reverses output of htmlEscape function for most unicode characters, excluding known html related
 * characters. Used for specific cases where rendering the utf codes is insufficient, such as safely
 * rendering form input fields from query string parameters.
 *
 * @param value Value to process
 * @param undoDangerousCharacters Optional, enables reversal of dangerous characters: `<>&`
 */
export const htmlUnescape = (value: string, undoDangerousCharacters = false): string => {
  const pattern = undoDangerousCharacters
    ? unsafeUnicodePatternsToReverse
    : unicodePatternsToReverse;

  return value.replaceAll(pattern, (_1, _2, characterCode) => {
    // uses capture group 2 to extract character code value
    const code = Number.parseInt(characterCode);
    return String.fromCharCode(code);
  });
};
